<template>
  <v-card flat>
    <v-card-text>
      <v-row align="center" no-gutters>
        <span class="title"># sans catégorie</span>
      </v-row>
      <v-row align="center">
        <v-col cols="2" v-for="(tag, index) in tags" :key="index">
          {{ tag }}
        </v-col>
      </v-row>
    </v-card-text>
    <v-card-text v-for="category in getTagCategories" :key="category.id">
      <v-row align="center" no-gutters>
        <span class="title">{{ category.name }}</span>
      </v-row>
      <v-row align="center">
        <v-col cols="2" v-for="(tag, index) in category.tags" :key="index">
          {{ tag }}
        </v-col>
      </v-row>
    </v-card-text>
  </v-card>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  name: "TagManagerViewer",
  async beforeRouteEnter(to, from, next) {
    next(async vm => {
      await vm.getData();
    });
  },
  async beforeRouteUpdate() {
    await this.getData();
  },
  computed: {
    ...mapGetters(["getTagCategories", "getRecipes", "getProducts"])
  },
  data() {
    return {
      tags: []
    };
  },
  methods: {
    async getData() {
      try {
        this.$store.dispatch("slo");
        await Promise.all([
          this.$store.dispatch("loadRecipes"),
          this.$store.dispatch("loadProducts"),
          this.$store.dispatch("loadTagCategories")
        ]);
        let tags = [
          ...new Set([
            ...this.getRecipes
              .filter(x => x.data !== null)
              .map(x => x.data.tags)
              .flat(),
            ...this.getProducts
              .filter(x => x.data !== null)
              .map(x => x.data.tags)
              .flat()
          ])
        ];
        const categoryTags = [];
        this.getTagCategories.forEach(c => categoryTags.push(...c.tags));
        this.tags = tags.filter(x => !categoryTags.includes(x));
      } finally {
        this.$store.dispatch("elo");
      }
    }
  }
};
</script>

<style></style>
